import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignIdReducer = (state: DesignState, action: PayloadAction<number | undefined>) => {
  state.designId = action.payload;
};

export default setDesignIdReducer;
